<script>
import ApiErrorMixin from '@/mixins/apiErrorMixin'

export default {
  name: 'ApiMixin',
  mixins: [ApiErrorMixin],
  methods: {
    async requestApiListData (action, params) {
      try {
        const response = await this.$store.dispatch(action, params)
        let paginatorTotal
        const modelList = response.data
        if (response.headers['x-total-count']) {
          paginatorTotal = parseInt(response.headers['x-total-count'], 10)
        } else {
          paginatorTotal = 50
        }

        return {
          modelList: modelList || [],
          total: paginatorTotal,
        }
      } catch (error) {
        console.log(error)
        return {
          modelList: null,
          total: null,
          error: true,
        }
      }
    },
    async requestApiItemData (action, params) {
      try {
        const response = await this.$store.dispatch(action, params)
        const model = response.data
        return {
          model,
        }
      } catch (error) {
        console.log(error)
        return {
          model: null,
          error: true,
        }
      }
    },
    async requestProfessionList (callback) {
      const list = await this.requestApiListData('organization/requestProfessionList', {})

      if (callback) {
        callback(list)
      }
      return list
    },
    async requestRegionList (callback, params = {}) {
      const defaultParams = { 'isLocale': true, 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      } else {
        if (!params['page[number]']) {
          params['page[number]'] = 1
        }
        if (!params['page[size]']) {
          params['page[size]'] = 250
        }
      }

      params.isLocale = true
      const list = await this.requestApiListData('organization/getRegionList', { params })

      if (callback) {
        callback(list)
      }
      return list
    },
    async requestVacancy (callback, id) {
      const vacancy = await this.requestApiListData('organization/getVacancy', { id })

      if (callback) {
        callback(vacancy)
      }
      return vacancy
    },
    async requestLocalityList (callback, params = {}) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      }
      if (!params['page[number]']) {
        params['page[number]'] = 1
      }
      if (!params['page[number]']) {
        params['page[size]'] = 250
      }
      const localityList = await this.requestApiListData(
        'organization/getLocalityList', { params })

      if (callback) {
        callback(localityList)
      }
      return localityList
    },
    async getVacancyRateList (callback, params = {}) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      }
      if (!params['page[number]']) {
        params['page[number]'] = 1
      }
      if (!params['page[number]']) {
        params['page[size]'] = 250
      }
      const result = await this.requestApiListData(
        'organization/getVacancyRateList', { params })

      if (callback) {
        callback(result)
      }
      return result
    },
    async getOfferList (callback, params = {}) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      }
      if (!params['page[number]']) {
        params['page[number]'] = 1
      }
      if (!params['page[number]']) {
        params['page[size]'] = 250
      }
      const result = await this.requestApiListData(
        'organization/getOfferList', { params })

      if (callback) {
        callback(result)
      }
      return result
    },
    async getOfferWorkDaySchedulerList (callback, params = {}) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      }
      if (!params['page[number]']) {
        params['page[number]'] = 1
      }
      if (!params['page[number]']) {
        params['page[size]'] = 250
      }
      const result = await this.requestApiListData(
        'organization/getOfferWorkDaySchedulerList', { params })

      if (callback) {
        callback(result)
      }
      return result
    },
    async getOfferPublicationSchedulerList (callback, params = {}) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      }
      if (!params['page[number]']) {
        params['page[number]'] = 1
      }
      if (!params['page[number]']) {
        params['page[size]'] = 250
      }
      const result = await this.requestApiListData(
        'organization/getOfferPublicationSchedulerList', { params })

      if (callback) {
        callback(result)
      }
      return result
    },
    async requestOfferBalanceStatement (callback, params = {}) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      }
      if (!params['page[number]']) {
        params['page[number]'] = 1
      }
      if (!params['page[number]']) {
        params['page[size]'] = 250
      }
      const localityList = await this.requestApiListData(
        'organization/getOfferBalanceStatement', { params })

      if (callback) {
        callback(localityList)
      }
      return localityList
    },
    async requestDictionaryList (callback, params = {}) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      }
      if (!params['page[number]']) {
        params['page[number]'] = 1
      }
      if (!params['page[number]']) {
        params['page[size]'] = 250
      }
      const modelList = await this.requestApiListData(
        'user/getDictionaryList', { params })

      if (callback) {
        callback(modelList)
      }
      return modelList
    },

    async requestOrganizationList (callback, params = {}, showLoader = false) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 100 }
      if (!params) {
        params = defaultParams
      } else {
        if (!params['page[number]']) {
          params['page[number]'] = 1
        }
        if (!params['page[size]']) {
          params['page[size]'] = 250
        }
      }
      if (showLoader) {
        this.showPageLoader()
      }

      const modelList = await this.requestApiListData(
        'organization/getOrganizationList', { params })

      if (callback) {
        callback(modelList)
      }
      if (showLoader) {
        this.hidePageLoader()
      }
      return modelList
    },
    async requestWorkerList (callback, params = {}, showLoader = false) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 100 }
      if (!params) {
        params = defaultParams
      } else {
        if (!params['page[number]']) {
          params['page[number]'] = 1
        }
        if (!params['page[size]']) {
          params['page[size]'] = 250
        }
      }
      if (showLoader) {
        this.showPageLoader()
      }

      const modelList = await this.requestApiListData(
        'organization/getWorkerList', { params })

      if (callback) {
        callback(modelList)
      }
      if (showLoader) {
        this.hidePageLoader()
      }
      return modelList
    },
    async requestExternalTaskList (callback, params = {}, showLoader = false) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 10 }
      if (!params) {
        params = defaultParams
      } else {
        if (!params['page[number]']) {
          params['page[number]'] = 1
        }
        if (!params['page[size]']) {
          params['page[size]'] = 250
        }
      }
      if (showLoader) {
        this.showPageLoader()
      }

      const modelList = await this.requestApiListData(
        'organization/getExternalOfferList', { params })

      if (callback) {
        callback(modelList)
      }
      if (showLoader) {
        this.hidePageLoader()
      }
      return modelList
    },
    async requestExternalTaskLog (callback, params = {}, showLoader = false) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 10 }
      if (!params) {
        params = defaultParams
      } else {
        if (!params['page[number]']) {
          params['page[number]'] = 1
        }
        if (!params['page[size]']) {
          params['page[size]'] = 250
        }
      }
      if (showLoader) {
        this.showPageLoader()
      }

      const modelList = await this.requestApiListData(
        'organization/getFileImportErrorReport', { params })

      if (callback) {
        callback(modelList)
      }
      if (showLoader) {
        this.hidePageLoader()
      }
      return modelList
    },
    async searchAddresses (callback, params) {
      const { searchQuery } = params
      if (!searchQuery || searchQuery.trim() === '') {
        return
      }

      const modelList = await this.requestApiListData(
        'organization/searchAddresses', { params: { address: searchQuery.trim() } })

      if (callback) {
        callback(modelList)
      }
      return modelList
    },
    async searchLaborer (callback, params) {
      const { searchQuery } = params
      if (!searchQuery || searchQuery.trim() === '') {
        return
      }

      const modelList = await this.requestApiListData(
        'user/getLaborerList', { params })

      if (callback) {
        callback(modelList)
      }
      return modelList
    },
    async requestUpdatePersonalInofrmationList (callback, params = {}, showLoader = false) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      } else {
        if (!params['page[number]']) {
          params['page[number]'] = 1
        }
        if (!params['page[size]']) {
          params['page[size]'] = 250
        }
      }
      if (showLoader) {
        this.showPageLoader()
      }

      const modelList = await this.requestApiListData(
        'user/getPersonalInformationUpdateRequestList', { params })

      if (callback) {
        callback(modelList)
      }
      if (showLoader) {
        this.hidePageLoader()
      }
      return modelList
    },
    async getLaborerIntegrationSettingList (callback, params = {}, showLoader = false) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      } else {
        if (!params['page[number]']) {
          params['page[number]'] = 1
        }
        if (!params['page[size]']) {
          params['page[size]'] = 250
        }
      }
      if (showLoader) {
        this.showPageLoader()
      }

      const modelList = await this.requestApiListData(
        'user/getLaborerIntegrationSettingList', { params })

      if (callback) {
        callback(modelList)
      }
      if (showLoader) {
        this.hidePageLoader()
      }
      return modelList
    },
    async getRelayPaymentReceiptList (callback, params = {}, showLoader = false) {
      const defaultParams = { 'page[number]': 1, 'page[size]': 250 }
      if (!params) {
        params = defaultParams
      } else {
        if (!params['page[number]']) {
          params['page[number]'] = 1
        }
        if (!params['page[size]']) {
          params['page[size]'] = 250
        }
      }
      if (showLoader) {
        this.showPageLoader()
      }

      const modelList = await this.requestApiListData(
        'organization/getRelayPaymentReceiptList', { params })

      if (callback) {
        callback(modelList)
      }
      if (showLoader) {
        this.hidePageLoader()
      }
      return modelList
    },

    async importExternalTask (params) {
      const { taskId } = params
      if (!taskId) {
        return
      }

      const response = await this.requestApiItemData(
        'organization/importExternalOffer', params)

      return response
    },
  }
}

</script>
